import routes from './routes';

export * from './Pages/index';
export * from './Components/index';
export default routes;
